import { render, staticRenderFns } from "./ByLawPart.vue?vue&type=template&id=a18db520"
import script from "./ByLawPart.vue?vue&type=script&lang=js"
export * from "./ByLawPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports